import { AImage } from 'components/atoms'
import { pragmaLogoImage } from 'utils/assets';

export const LogoPragma = () => (
  <AImage className='logo-pragma' url={pragmaLogoImage} alt='Pragma Logo' />
);
